var React = require('react');
var cx = require('classnames');

var Input = require('./input');

class EditFieldModal extends React.Component {
  /**
   * A reusable modal with an input field.
   *
   * @param {object} props
   * @param {string} props.id - Id of the modal confirmation div, will be 'modal-confirmation-{{PROVIDED_ID}}'
   * @param {string} props.title - Title of the modal
   * @param {string} props.label - Label for the input
   * @param {string} props.putUrl - Where are going to send this thing?
   * @param {string} props.paramName - name of the param to send up the chain
   * @param {string} props.owningEntityParam - Param for the object that we're updating with this input
   * @param {string} props.placeholder - placeholder text for the input
   * @param {string} props.submit_text - the text used as the submit button text
   */

  constructor (props) {
    super(props);
    this.state = { inputValue: null };
  }

  _setInputValue(e) {
    this.setState({inputValue: e.target.value});
  }

  _submitInput() {
    if (this.state.inputValue != null) {
      var params = {id: this.props.owningEntityParam};
      params[this.props.paramName] = this.state.inputValue;

      $.ajax({
        type: 'PUT',
        url: this.props.putUrl,
        data: params,
        success: function (data, textStatus, xhr) {
          window.location.reload(true);
        },
        error: function(xhr, textStatus) {
          HRB.utils.basicFailAndReload(xhr);
        }
      });
    } else {
      alert('This field cannot be blank!');
    }
  }

  _onCancel() {
    $(document).trigger('statuspage.confirm.' + this.props.id + '.canceled');
    if (this.props.onCancel) { this.props.onCancel(); }
  }

  render() {
    let className = cx('modal hide fade modal-confirmation', this.props.className);

    return (
      <div className={className} id={"modal-confirmation-" + this.props.id} style={{display: 'none'}}>
        <div className="modal-header">
          <a href="#" data-dismiss="modal" className="close">×</a>

          <h4>{this.props.title}</h4>
        </div>
        <div className="modal-body">
          <Input type="text"
                 label={this.props.label}
                 inputClass="full-width"
                 name={this.props.paramName}
                 placeholder={this.props.placeholder}
                 onChange={this._setInputValue.bind(this)} />
        </div>
        <div className="modal-footer">
          <button className="cpt-button style-primary"  data-dismiss="modal" id={"btn-confirm-" + this.props.id} onClick={this._submitInput.bind(this)} >{this.props.submit_text}</button>
          <a href="#" id={"btn-cancel-" + this.props.id} data-dismiss="modal" className="close" onClick={this._onCancel.bind(this)} >Cancel</a>
        </div>
      </div>
    );
  }
}

module.exports = EditFieldModal;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/edit_field_modal.jsx